import React from 'react';
import Slider from 'react-slick';
import './TripCarousel.css'; // Add your custom styling here
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const TripCarousel = () => {
};

export default TripCarousel;
